const cloudService = async (formData,opt,type) => {
  const response = await fetch(`REST/controllers/cloudController?opt=${opt}&type=${type}`,{
    method: 'POST',
    mode: 'cors',
    body: formData
  })
  .then( response => response.json())
  return response;
}

export{
  cloudService
}